module.exports = __webpack_public_path__ + "static/media/edit-disabled.4afec4b1.svg";